/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		this.parent = this.closest('.product-recommendations--parent');

	}
	fetchProducts() {
        let url = this.dataset.url;
        // random
        if(this.dataset.ids){
          const idsArray = this.dataset.ids.split(',');
          const randomIndex = Math.floor(Math.random() * idsArray.length);
          url = url.replace("{product_id}", idsArray[randomIndex]);
        }
        
		fetch(url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
                    
					this.innerHTML = recommendations.innerHTML.replaceAll("slide-show-temp", "slide-show");

					if ( this.parent ) {
						this.parent.classList.add('product-recommendations--full');

						if ( document.body.classList.contains('open-cart')) {
							this.parent.classList.add('active');
						}

                      
					}
                    // if(this.parentNode.classList.contains("cust-product-complementary-section")){
                    //    const atcBtn = this.parentNode.querySelector(".single-add-to-cart-button");
                    //     if(atcBtn){
                    //       atcBtn.addEventListener('click', () => {
                    //         const variants = this.parentNode.querySelectorAll("product-card[data-variant-id]");
                    //         let formData = {
                    //            'items': []
                    //           };
                    //         variants.forEach(item => {
                    //           formData.items.push({'id': item.dataset.variantId,'quantity': 1})
                    //         })
                            
                    //         fetch(window.Shopify.routes.root + 'cart/add.js', {
                    //           method: 'POST',
                    //           headers: {
                    //             'Content-Type': 'application/json'
                    //           },
                    //           body: JSON.stringify(formData)
                    //         })
                    //         .then(response => {
                    //           return response.json();
                    //         }).then(data => {
                    //           console.log(data,"data");
                    //         })
                    //         .catch((error) => {
                    //           console.error('Error:', error);
                    //         });
                    //     });
                    //   }
                    // }
				}

				this.classList.add('product-recommendations--loaded');


                if(this.classList.contains("cart-drawer--recommendations") && document.body.clientWidth < 1068){
                  const container = this.querySelector('.cart-drawer--recommendations--products');
                  const leftArrow = this.querySelector('.carsousel-btns .flickity-prev');
                  const rightArrow = this.querySelector('.carsousel-btns .flickity-next');
                  container.addEventListener('scroll', updateArrows);
                  
                  function updateArrows() {
                    const scrollLeft = Math.ceil(container.scrollLeft);
                    const scrollRightEdge = Math.floor(scrollLeft + container.clientWidth);
                    const scrollWidth = Math.floor(container.scrollWidth);
                    if (scrollLeft <= 0) {
                      leftArrow.classList.add("disabled");
                    } else {
                      leftArrow.classList.remove("disabled");
                    }
                    if (scrollRightEdge >= scrollWidth) {
                      rightArrow.classList.add("disabled");
                    } else {
                      rightArrow.classList.remove("disabled");
                    }
                  }
                  
                  leftArrow.addEventListener('click', () => {
                    if(!leftArrow.classList.contains("disabled")){
                      scrollToPrev();
                    }
                  });
                  rightArrow.addEventListener('click', () => {
                    if(!rightArrow.classList.contains("disabled")){
                      scrollToNext();
                    }
                  });

                  let isScrolling = false;
                  
                  function scrollToNext() {
                    if (isScrolling) return;
                    isScrolling = true;
                    
                    const item = container.querySelector('.product-cart-item'); 
                    if (item) {
                      container.scrollBy({ left: item.offsetWidth, behavior: 'smooth' });

                      setTimeout(() => {
                        isScrolling = false;
                        updateArrows(); 
                      }, 500); 
                    }else{
                      isScrolling = false;
                    }
                  }
                  function scrollToPrev() {
                    if (isScrolling) return;
                    isScrolling = true;
                    
                    const item = container.querySelector('.product-cart-item');
                    if (item) {
                      container.scrollBy({ left: -item.offsetWidth, behavior: 'smooth' });
                      
                      setTimeout(() => {
                        isScrolling = false;
                        updateArrows();
                      }, 500); 
                    }else{
                      isScrolling = false;
                    }
                  }
                  updateArrows();
                }

			})
			.catch(e => {
				console.error(e);
			});
	}
	connectedCallback() {
		this.fetchProducts();
	}
}

customElements.define('product-recommendations', ProductRecommendations);
